import { Input as AntdInput } from 'antd';
import { InputProps as AntdInputProps } from 'antd/lib/input/Input';
import * as React from 'react';

export interface InputsProps extends AntdInputProps {
  type?: 'on-white' | 'on-gray';
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  placeHolder?: string;
}

export const Input = (props: InputsProps) => {
  const { className, type = 'on-white', iconLeft, iconRight, ...rest } = props;

  const inputRef = React.useRef(null);

  return (
    <AntdInput
      ref={inputRef}
      onClick={() => inputRef?.current?.focus()}
      className={`dol-inputV2 type-${type} ${className}`}
      prefix={iconLeft}
      suffix={iconRight}
      {...rest}
    />
  );
};
